import { combineReducers } from 'redux'
import snackbar, { SnackbarState } from './snackbar'
import dialog, { DialogState } from './dialog'

export interface RootState {
  snackbar: SnackbarState
  dialog: DialogState
}

const app = combineReducers<RootState>({
  snackbar,
  dialog
})

export default app
